import Button from "components/base/Button";
import Page from "components/base/Page";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { FiDownload } from "react-icons/fi";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { download } from "utils/http";

function CommercialInvoicePreview() {
  const { id: shipmentId } = useParams();
  const { state } = useLocation();
  const [downloading, setDownloading] = useState("");
  if (!state)
    return <Navigate to={`/shipment/shipments/${shipmentId}`} replace />;
  const { shipment, data, html } = state;
  const exportFile = (fileFormat) => {
    setDownloading(fileFormat);
    download(
      `/shipment/${shipment.id}/commercial-invoice/${fileFormat}/`,
      `Commercial Invoice #${shipment.invoiceNumber}.${fileFormat}`,
      data,
    )
      .catch((error) => Alert("error", String(error)))
      .finally(() => setDownloading(""));
  };
  return (
    <Page
      title="Preview Commercial Invoice"
      backTo={`/shipment/shipments/${shipment.id}`}
      rightButtons={
        <div className="flex gap-6">
          <Button
            icon={<FiDownload />}
            loading={downloading === "pdf"}
            onClick={() => exportFile("pdf")}
          >
            Generate PDF
          </Button>
          <Button
            icon={<FiDownload />}
            loading={downloading === "xlsx"}
            onClick={() => exportFile("xlsx")}
          >
            Generate Excel
          </Button>
        </div>
      }
    >
      <div className="flex flex-col flex-1">
        <iframe
          title="Commercial Invoice Preview"
          className="flex-1 w-full bg-white"
          srcDoc={html}
        />
      </div>
    </Page>
  );
}

export default CommercialInvoicePreview;
